import { Text, View } from '@react-pdf/renderer';
import React, { PureComponent } from 'react';
import { styles as pdfStyles } from 'app/components/panels/inp/pdf/PdfDocument';
import { NetworkSummaryDto, RegulatedInfo } from 'app/model/SOL49';

export class NetworkSummary extends PureComponent<{ summary: NetworkSummaryDto }> {
    private selectedOnly = (regulatedInfos: { [p: string]: RegulatedInfo }): { [p: string]: RegulatedInfo } => {
        return Object.fromEntries(Object.entries(regulatedInfos).filter(([_, info]) => info.selected));
    };

    render() {
        return (
            <View>
                <Text style={pdfStyles.section_title}>Network Summary</Text>
                <View style={{ padding: '10px' }}>
                    <Text style={pdfStyles.h3_underlined}>General</Text>
                    <Text style={{ paddingLeft: '10px' }}>{this.props.summary.expectedFlightInfo}</Text>
                    {this.props.summary.generalInfo?.split('\n').map(this.renderText)}
                </View>
                <View style={{ padding: '10px' }}>
                    <Text style={pdfStyles.h3_underlined}>Aerodromes</Text>
                    {this.renderAdAsDesc(this.selectedOnly(this.props.summary.aerodromes))}
                    {this.props.summary.aerodromesFreeText.map(this.renderText)}
                </View>
                <View style={{ padding: '10px' }}>
                    <Text style={pdfStyles.h3_underlined}>Airspace</Text>
                    {this.renderAdAsDesc(this.selectedOnly(this.props.summary.airspace))}
                    {this.props.summary.airspaceFreeText.map(this.renderText)}
                </View>
                <View style={{ padding: '10px' }}>
                    <Text style={pdfStyles.h3_underlined}>Weather</Text>
                    {this.props.summary.weather?.split('\n').map(this.renderText)}
                </View>
            </View>
        );
    }

    private renderText = (text: string, idx: number) => (
        <Text key={idx} style={{ paddingLeft: '10px' }}>
            {text}
        </Text>
    );

    private renderAdAsDesc = (map: { [p: string]: RegulatedInfo }) => (
        <View style={{ flexDirection: 'row', paddingLeft: '10px' }}>
            <View>
                {Object.values(map).map((info, i) => (
                    <Text key={i} style={{ fontWeight: 'bold' }}>
                        {info.location}
                    </Text>
                ))}
            </View>
            <View>
                {Object.values(map).map((info, i) => (
                    <Text key={i} style={{ paddingLeft: '5px' }}>
                        {info.info}
                    </Text>
                ))}
            </View>
        </View>
    );
}
